"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const carabiners_1 = require("@clearsummit/carabiners");
const core_1 = require("@emotion/core");
const constants_1 = require("@/constants");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const ProfileCard = ({ user, className, }) => ((0, core_1.jsx)("div", { className: (0, carabiners_1.joinStr)(styles_scss_1.default.container, className) },
    (0, core_1.jsx)("img", { src: user && user.profilePhotoUrl ? user.profilePhotoUrl.uri : constants_1.Images.userPlaceholder, alt: "", className: styles_scss_1.default.image }),
    (0, core_1.jsx)("div", { className: styles_scss_1.default.userInfo },
        (0, core_1.jsx)("span", { className: styles_scss_1.default.name }, user ? user.fullName : ''),
        (0, core_1.jsx)("span", { className: styles_scss_1.default.email }, user ? user.email : ''))));
ProfileCard.defaultProps = {
    className: undefined,
};
exports.default = ProfileCard;
